import axios from "axios";
import defaultAxios from "./axios";

const { API_URL } = defaultAxios;

export const publicAxios = axios.create({
  baseURL: API_URL,
});
